module.exports = "https://qp-assets.quero.com/assets/images/credit-card-brands/amex-nobg.svg?3085a6548693ff95e614661afe96b135";